import { render } from "./PackingLineView.vue?vue&type=template&id=615b8ade&scoped=true"
import script from "./PackingLineView.vue?vue&type=script&lang=js"
export * from "./PackingLineView.vue?vue&type=script&lang=js"

import "./PackingLineView.vue?vue&type=style&index=0&id=615b8ade&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-615b8ade"]])

export default __exports__